// @inheritedComponent Paper

import * as React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import withStyles from '@material-ui/core/styles/withStyles'
import Box from '@material-ui/core/Box'
import MuiPaper from '@material-ui/core/Paper'

export const styles = {
  root: {
    position: 'relative',
  },
}

const Paper = React.forwardRef(function Paper(props, ref) {
  const { classes, className, ...other } = props

  const componentProps = {
    className: clsx(classes.root, className),
    ref,
    ...other,
  }

  return <MuiPaper component={Box} variant="outlined" square {...componentProps} />
})

Paper.propTypes = {
  classes: PropTypes.object.isRequired,
  className: PropTypes.string,
}

export default withStyles(styles)(Paper)
